const Loader = () => {
  return (
    <div
      className="position-absolute top-50 start-50 translate-middle"
      style={{
        zIndex: 1060,
        backgroundColor: "#ffffff",
        opacity: "0.75",
        width: "100%",
        height: "100%",
      }}
    >
      <div
        className="spinner-grow position-fixed top-50 start-50 translate-middle"
        style={{ width: "3rem", height: "3rem" }}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
